<script setup>
import { ref, reactive, watch,onMounted } from "vue";
import { useApiStore } from "@/stores/api";
import { useUserStore } from "@/stores/user";
import { usePatientStore } from "@/stores/patient";
import { useCrfStore } from "@/stores/crf";
import NewPatient from "@/components/NewPatient.vue";
import CRF from "@/components/CRF.vue";
import { useRouter } from "vue-router";
import upload from "@/components/upload.vue";
import { useCommonStore } from "@/stores/common";
import YBXX from "@/components/YBXX.vue";
import { ElMessage, arrowMiddleware } from "element-plus"
import JHWFS from "@/components/JHWFS.vue";
import JHW from "@/components/JHW.vue";
const userStore = useUserStore();
const router = useRouter();
const commonStore = useCommonStore();
const selectHost = ref(userStore.hospital);
const hostOptions = ref([])
//是否登录
let isLogin = sessionStorage.getItem("isLogin");

if (!isLogin) {
  router.replace({ name: "login" });
}
if(userStore.role.includes('0') || userStore.role.includes('3')){
  commonStore.getHospitalList().then((res) => {
  hostOptions.value = res.data.map((v) => {
    return {
      value: v.hospital,
      label: v.hospital,
    };
  });
});
}
//当前查看的医院
const actionhospital = ref("");
//获取所有医院信息
let hospitals = ref([])
let allCount = ref(0)
const getHopitals =async ()=>{
  // if(!(userStore.role.includes('0') || userStore.role.includes('3')) ) return
  allCount.value = 0
  let arr = []
  let arr1 = await userStore.getHospitals()
  arr = arr1.data
  let index =null
  arr.forEach((element,i) => {
    
    if(element.hospital == userStore.hospital) {
      index = i 
    }
    
    if(element.hospital != '之几'){
      allCount.value += element.count
    }
  });
  let ownHospital = arr[index]
  arr.splice(index,1)
  arr.unshift(ownHospital)
  hospitals.value = arr
}
//是否是管理员
let is_lead = ref(false)
if(userStore.role.includes('0') || userStore.role.includes('3')){
// console.log(userStore.is_lead)
  is_lead.value = true
  // 处理医院
  getHopitals()
  
}

const dialog = reactive({
  id: null,
  showDialog: false,
  title: "",
  type: "",
  patient: {},
  crfForm: {}
});

// 表头信息（访视期，包含的每块）
const crfStore = useCrfStore();
let crfForms = crfStore.forms;
// console.log(crfForms,"crf");


// 计划外(一个患者名下所有患者的计划外)
const jhw = reactive([])

// 计划外集合
const tabtitles = ref([])

const patientStore = usePatientStore();
// 提交提示
const loading = ref(true);

//展示排除还是入选
let isEnrollment = ref(true)
//排除和入选的人数
let enrollmentCount = ref(0)
// 拿到医生名下所有的患者
const tableData = ref([]);
const index = async ()=> {
  // debugger
  enrollmentCount.value = 0
  loading.value = true;
   let res = await patientStore.index(actionhospital.value)
    // console.log(res,"打印");
    tabtitles.value = 1
    tableData.value = res;
    loading.value = false;
      //是否排除：否（同时考虑病理复核排除和排除标准排除）
      //是否入选：是
      // 排除标准15项字段列表
      const excludeFields = [
        "Budd-Chiari 综合征",
        "先天性肝纤维化",
        "结节病",
        "肝窦阻塞综合征（SOS）",
        "是否存在肝紫癜病？",
        "是否有骨髓移植史？",
        "是否有肝活检诊断为肝血吸虫病（孤立阳性血清学不是排除标准）？",
        "是否有心力衰竭或行Fontan手术？",
        "是否有Abernethy综合征？",
        "是否有遗传性出血性毛细血管扩张？",
        "是否有慢性胆汁淤积性疾病？（如PBC、PSC）",
        "是否有恶性肿瘤肝脏浸润？",
        "是否有淀粉样变？",
        "α1 抗胰蛋白酶缺乏症及肝豆状核变性等遗传代谢性肝脏疾病",
        "研究者认为不适合参加本研究的患者"
      ];

      tableData.value = tableData.value.map(e=>{
        let ble = true // 默认为排除

        // 病理复核排除优先级最高
        if(e.fields.pathologyReview === '复核排除'){
          ble = true
        }
        // 极早期患者无需遵循排除标准
        else if(e.fields["排除标准"]?.["极早期患者"] === "是"){
          ble = false
          enrollmentCount.value++
        }
        // 检查排除标准15项，任一项为"是"则排除
        else if(excludeFields.some(key => e.fields["排除标准"]?.[key] === "是")){
          ble = true
        }
        // 都不满足则入组
        else {
          ble = false
          enrollmentCount.value++
        }

        return {...e,isExclude:ble}

      })
    // console.log(tableData.value,"chuliwancheng")
    // console.log(res[0])
    //只能在处理每一个人的计划外和访视期顺序问题
    res.forEach((e,i) =>{
        tableData.value[i].crf = [] //{name,type,module}
      
        // 处理计划外的时间格式
        tableData.value[i].fields.jhw = e.fields?.jhw?.map(el =>{
            let time = el.name.split('外')[1]
            // console.log(time,"时间")
            return {...el,time:time,isjhw:true}
        }) || []
        
        //处理普通的格式 - 添加固定的order字段确保顺序
        let arr = crfForms.map((el ,index) =>{
            let time = e.fields[el.type]?.['访视日期'] || ''
            return {...el,time:time, order: index}
        })
        
        // 计划外访视添加一个很大的order值，确保按时间排序
        let jhwWithOrder = tableData.value[i].fields.jhw.map(el => ({...el, order: 999}))
        
        let arrs = [...jhwWithOrder,...arr]
        arrs.sort((a,b)=>{
            // 先按order排序（保证普通访视期固定顺序），order相同时按时间排序（计划外访视）
            if(a.order !== b.order) {
              return a.order - b.order;
            }
            // order相同时按日期排序（主要用于计划外访视之间的排序）
            return a.time.localeCompare(b.time);
        })
        // console.log(arrs,"==============")
        tableData.value[i].crfs = arrs


    })
    searchnames.value = tableData.value
  };
  
 let searchname = ref('')
let searchnames = ref([])
  const searchName = (name) => {
    // if(searchnames.value.length > 0){
      tableData.value = searchnames.value
    // }else{
    //   searchnames.value = tableData.value
    // }
    let arr = []
    // 搜索框为空时，重置数据并重新计算入组人数
    if(!name.trim()) {
      enrollmentCount.value = 0
      tableData.value = tableData.value.map(e=>{
        if(e.isExclude === false){
          enrollmentCount.value++
        }
        return e
      })
      return
    }
    tableData.value?.forEach((e) => {
      // console.log(e.fields['患者姓名'],"name")
      if(e.fields['患者姓名']?.includes(name)){
        // console.log(e.name,"name")
        arr.push(e)
      }
    });
    tableData.value = arr

    // 排除标准15项字段列表
    const excludeFields = [
      "Budd-Chiari 综合征",
      "先天性肝纤维化",
      "结节病",
      "肝窦阻塞综合征（SOS）",
      "是否存在肝紫癜病？",
      "是否有骨髓移植史？",
      "是否有肝活检诊断为肝血吸虫病（孤立阳性血清学不是排除标准）？",
      "是否有心力衰竭或行Fontan手术？",
      "是否有Abernethy综合征？",
      "是否有遗传性出血性毛细血管扩张？",
      "是否有慢性胆汁淤积性疾病？（如PBC、PSC）",
      "是否有恶性肿瘤肝脏浸润？",
      "是否有淀粉样变？",
      "α1 抗胰蛋白酶缺乏症及肝豆状核变性等遗传代谢性肝脏疾病",
      "研究者认为不适合参加本研究的患者"
    ];

    enrollmentCount.value = 0
    //是否排除：否（同时考虑病理复核排除和排除标准排除）
    //是否入选：是
    tableData.value = tableData.value.map(e=>{
      let ble = true // 默认为排除

      // 病理复核排除优先级最高
      if(e.fields.pathologyReview === '复核排除'){
        ble = true
      }
      // 极早期患者无需遵循排除标准
      else if(e.fields["排除标准"]?.["极早期患者"] === "是"){
        ble = false
        enrollmentCount.value++
      }
      // 检查排除标准15项，任一项为"是"则排除
      else if(excludeFields.some(key => e.fields["排除标准"]?.[key] === "是")){
        ble = true
      }
      // 都不满足则入组
      else {
        ble = false
        enrollmentCount.value++
      }

      return {...e,isExclude:ble}

    })
  };
 watch(searchname, (newVal) => {
  // console.log(newVal, "newVal")
    searchName(newVal)
 })

// 显示（crf）对话框
let showDialog = (id, crfForm = {}) => {
  // console.log(crfForm, "crfForm")
  // console.log(crfForm.type, "crfForm.type")
  // return;
  loading.value = true;
  // 避免 id，showDialog 都没有变，导致弹窗不显示，所以先设置 showDialog 为 false
  dialog.showDialog = false;
  setTimeout(() => {
    
    dialog.id = id;
    // 拿到访视期传过去（子页面）
    dialog.crfForm = crfForm;
    dialog.showDialog = true;
  }, 0);
};

let handleOpenDialog = () => {
  loading.value = false;
};

// 关闭对话框
let closeDialog = (formName) => {
  dialog.showDialog = false;
  dialog.patient = null;
};
// onMounted(() => {
  // 获取患者列表
  index();
  // index(actionhospital.value);
// });

// 增加患者成功后的操作
 const create_new = (data)=>{
    index()//患者列表数据重新请求
    // index(actionhospital.value);
    getHopitals()
 };

// 提交上传中提示
let crfLoading = ref(false)

// 拿到医生id
const userId = useUserStore()
// console.log(userId.id,"id");

let detailsShow = ref(false)
const model = reactive({  
  user_id:userId.id,
})

// 点击姓名修改一般信息
// 虽然只是修改一般信息，但是要获取患者的全部信息，然后更新全部信息中的一般信息，再把全部信息更新发送到服务器
// 点击姓名事件
const details =async (id)=>{
  // console.log(id,"一般信息");
  // return 
  //  正常点击和跳转都需要请求
  // 获取患者的全部信息
      let getdata = await commonStore.getData(id)
      model.id = getdata.data.id;
      model.fields = getdata.data.fields;
      // if (typeof (model.fields[`${crfFormses[crfFormIndex.value].type}`]) === "undefined") {
      //   model.fields[`${crfFormses[crfFormIndex.value].type}`] = {};
      // }
      // console.log(getdata,model,"详细的一般信息");
      // 注意代码顺序，应该把所有的数据处理好以后，再去渲染子组件（设置显示），保证传入子组件 的变量是有值的
      detailsShow.value = true

};
// 子组件ref(验证身份证)
let IdCard = ref()
// 验证手机号
let phonefun = ref()
// 规则结果
let formRef = ref()
// 规则
const formRule = reactive({});

// 一般信息修改提交
const submitDetails =async (formEl)=>{
  // console.log(22222)
 if(!IdCard.value.phonefun()) return

  formEl.validate( async (valid, fields) => {
    if (!valid) return 
    // 表单检验完成后，调用子方法，判断身份证后六位是否合法
    let idcard = await IdCard.value?.idCard()
    // console.log(idcard,"调用子方法");
    if(!idcard) return
     // 验证手机号
     if(!IdCard.value.phonefun()) return

    crfLoading.value = true
    let res = await crfStore.update(model)
    crfLoading.value = false //关闭加载
    detailsShow.value = false//关闭弹窗
    if (res.result != "success") return ElMessage.error(res.msg)
    
    index();
  })
};

// 计划外新增
const planoutside = reactive({
    id:'',
    planname:'',
    planDialog:false
});
 const planfun = (id)=>{
  // console.log(999999999999,id)
  planoutside.planDialog = true,
  planoutside.id = id
 }
 
 
// 关闭计划外填写对话框
let pandDialog = () => {
  // planoutside.showDialog = false;
  planoutside.planDialog = false

};
// 取消（关闭计划外填写对话框）
const handleCloseDrawer = ()=>{
  planoutside.planDialog = false
  showjhw.showDialog = false
}
 
const update = ()=>{
  index()
  // index(actionhospital.value);
  planoutside.planDialog = false
  showjhw.showDialog = false

}
 
let date = ref('')
 
const renewdate = (e)=>{
  // console.log(e,'e')
  date.value = e
};
// 计划外展示

 const showjhw = reactive({
  id:null,
  crf:{},
  showDialog:false
 })
 const showJhw = (id,crf={})=>{
    showjhw.id = id
    showjhw.crf = crf
    showjhw.showDialog = true
 }

 const screenmian = reactive({
  size :'',
  rowWidth : '',
  colsapn :'',
  labelWidth : ''
})


//  根据屏幕的大小设置弹窗和表格的大小
const watchWindowSize = ()=>{

// 获取窗口的宽度和高度，不包括滚动条
var w = document.documentElement.clientWidth;
var h = document.documentElement.clientHeight;
// 打印结果
// result.innerHTML = "宽: " + w + ", " + "高: " + h
// console.log(w,'wwwwwwwwwww')
  if (w > 1000) {
    // 弹窗的宽度设置80% 否则100%
    screenmian.size = 80
    screenmian.rowWidth = 100
    screenmian.colsapn= 15
    screenmian.labelWidth = 250
  }else{
    screenmian.size = 100
    screenmian.rowWidth = 120
    screenmian.colsapn = 24
    screenmian.labelWidth = 160
  }

}

watchWindowSize()

window.onresize = ()=>{
  watchWindowSize()

}
// 窗口变化事件
window.onload = ()=>{
// watchWindowSize()
};

// 个人的列表展开和折叠
// 判断是否需要折叠（需要判断单独的人）
let flodshowarrs = reactive([])
  for(let index = 0; index < tableData.length; index++){
    flodshowarrs[index].push(false)
  }
  const funflod = (index)=>{
    flodshowarrs[index] = !flodshowarrs[index]

  }

// 点击变色
// let colorArrys = reactive([...new Array(hospitals.length).keys()].map(()=>'danger'))
let colorIndex = ref(0)
let lists_show = ref(true)
// 点击医院请求相应的数据
const btnClick =async (item,index)=>{

  // console.log(item,index)
  if (colorIndex.value == index) {
    return
  }
  isEnrollment.value = true
  
  lists_show.value = false
  colorIndex.value = index
  
  loading.value = true;
  actionhospital.value = item.hospital
  let data = await patientStore.index(item.hospital)
      console.log(data,"拿到其他的医院的数据")
      // tableData.value = [...data] 
      tableData.value = data
      enrollmentCount.value = 0
      //是否排除：否（同时考虑病理复核排除和排除标准排除）
      //是否入选：是
      // 排除标准15项字段列表
      const excludeFields = [
        "Budd-Chiari 综合征",
        "先天性肝纤维化",
        "结节病",
        "肝窦阻塞综合征（SOS）",
        "是否存在肝紫癜病？",
        "是否有骨髓移植史？",
        "是否有肝活检诊断为肝血吸虫病（孤立阳性血清学不是排除标准）？",
        "是否有心力衰竭或行Fontan手术？",
        "是否有Abernethy综合征？",
        "是否有遗传性出血性毛细血管扩张？",
        "是否有慢性胆汁淤积性疾病？（如PBC、PSC）",
        "是否有恶性肿瘤肝脏浸润？",
        "是否有淀粉样变？",
        "α1 抗胰蛋白酶缺乏症及肝豆状核变性等遗传代谢性肝脏疾病",
        "研究者认为不适合参加本研究的患者"
      ];

      tableData.value = tableData.value.map(e=>{
        let ble = true // 默认为排除

        // 病理复核排除优先级最高
        if(e.fields.pathologyReview === '复核排除'){
          ble = true
        }
        // 极早期患者无需遵循排除标准
        else if(e.fields["排除标准"]?.["极早期患者"] === "是"){
          ble = false
          enrollmentCount.value++
        }
        // 检查排除标准15项，任一项为"是"则排除
        else if(excludeFields.some(key => e.fields["排除标准"]?.[key] === "是")){
          ble = true
        }
        // 都不满足则入组
        else {
          ble = false
          enrollmentCount.value++
        }

        return {...e,isExclude:ble}

      })
      // searchnames.value = tableData.value
    

      //只能在处理每一个人的计划外和访视期顺序问题
      data.forEach((e,i) =>{
        tableData.value[i].crf = [] //{name,type,module}
      
        // 处理计划外的时间格式
        tableData.value[i].fields.jhw = e.fields?.jhw?.map(el =>{
            let time = el.name.split('外')[1]
            // console.log(time,"时间")
            return {...el,time:time,isjhw:true}
        }) || []
        
        //处理普通的格式 - 添加固定的order字段确保顺序
        let arr = crfForms.map((el ,index) =>{
            let time = e.fields[el.type]?.['访视日期'] || ''
            return {...el,time:time, order: index}
        })
        
        // 计划外访视添加一个很大的order值，确保按时间排序
        let jhwWithOrder = tableData.value[i].fields.jhw.map(el => ({...el, order: 999}))
        
        let arrs = [...jhwWithOrder,...arr]
        arrs.sort((a,b)=>{
            // 先按order排序（保证普通访视期固定顺序），order相同时按时间排序（计划外访视）
            if(a.order !== b.order) {
              return a.order - b.order;
            }
            // order相同时按日期排序（主要用于计划外访视之间的排序）
            return a.time.localeCompare(b.time);
        })
        // console.log(arrs,"==============")
        tableData.value[i].crfs = arrs


    })
    searchnames.value = tableData.value
    //清空搜索框
    searchname.value = ''
    // tableData.value = data;
    lists_show.value = true
    loading.value = false;
}
// console.log(userStore.position)
// console.log(crfForms,"访视期")

let ctpcount = ref(0)
const updataCtp = () =>{
  ctpcount.value ++
  if( ctpcount.value == 5){
    commonStore.computectp()
    // console.log('触发')
    
  }
}
// 0=待处理, 1=已处理, 2=已撤销, 3=已确认
const getquestiontype = (type) =>{
  return ['质疑','质疑处理','质疑撤销','质疑关闭'][type] + '通知'
}
const innerlist = ref([])
watch(() => commonStore.innermsg, (newVal, oldVal) => {
    if(newVal){
      commonStore.getinnermsg(userStore.id).then(res=>{
          innerlist.value = res.data
      }
      )
    }
})

 ;
</script>

<template>
  <!-- <div id="inner" style="height: 100%;"></div> -->
  <!-- 增加新患者 -->
  <NewPatient @create1="create_new" ></NewPatient>
  <!-- 计划外访视填写 -->
  <el-drawer v-model="planoutside.planDialog" :title="`计划外（${date}）`"
             :close-on-click-modal="false" :close-on-press-escape="false" 
             :destroy-on-close="true"
             @close="handleCloseDrawer" direction="rtl" :size="`${screenmian.size}%`"
             class="box">
      <JHWFS  :id="planoutside.id" :planname="planoutside.planname" :show="planoutside.planDialog"
      @close="pandDialog"  @renewdate="renewdate"
      @update="update"
      ></JHWFS>
     
  </el-drawer>
  <!-- CRF -->
  <template v-if="dialog.showDialog">
      <CRF 
        :id="dialog.id"
        :patient="dialog.patient"
        :crfForm="dialog.crfForm"
        :crfForms = "crfForms"
        :showDialog="dialog.showDialog"
        @open="handleOpenDialog"
        @create="index"
        @close="closeDialog('CRF')"
        @update="index"
      ></CRF>
  </template>
    
  <!-- 计划外访视查看 -->
  <el-drawer v-model="showjhw.showDialog" :title="showjhw.crf.name"
            :close-on-click-modal="false" :close-on-press-escape="false" 
            :destroy-on-close="()=>true"
            @close="handleCloseDrawer" direction="rtl" :size="`${screenmian.size}%`"
            class="box">
      
      <JHW v-if="showjhw.showDialog" :id="showjhw.id" :crf="showjhw.crf" @update="update"  @close="showjhw.showDialog =!showjhw.showDialog" ></JHW>
  </el-drawer>

  <!-- 修改一般信息 -->
  <div v-if="detailsShow">
    <template class="screenshow">
    </template>
      <el-drawer v-model="detailsShow" title="修改一般信息" direction="rtl" :size="`${screenmian.size}%`">
        <el-row v-loading.fullscreen.lock="crfLoading" element-loading-text="信息提交中"  :style="`width:${screenmian.rowWidth}% ;overflow: auto;`">
            <el-col :span="screenmian.colsapn">
                <el-form v-if="model.id" :model="model" size="default" label-position="left" :label-width="`${screenmian.labelWidth}px`" ref="formRef" v-loading.fullscreen.lock="crfLoading" element-loading-text="信息提交中" 
                            :rules="formRule" :scroll-to-error="true"
                            :scroll-into-view-options="{ behavior: 'smooth', block: 'start', inline: 'nearest' }">
                        <YBXX ref="IdCard" :formModel="model" :fold="true" @phones="submitDetails(formRef)"></YBXX>
                        
              </el-form>
          </el-col>
        </el-row>
        <template #footer>
          <el-button @click="detailsShow = false">取消</el-button>
          <el-button type="primary" @click="submitDetails(formRef)">确定</el-button>
        </template>
      </el-drawer>
  </div>
  <!-- 内容模块 -->
  <!-- 管理员查看全部患者数量 -->
  <p v-if="is_lead" style="margin: 0;" @click="updataCtp()">总患者：{{ allCount }}</p>
  <!-- 判断是否是负责人登录 -->
  <div class="isLead" v-if="is_lead">
      <template v-for="(item, index) in hospitals" :key="index">
        <el-button v-if="userStore.position == '工程师' || item.hospital != '之几'" :class="['button',index == colorIndex?'colorIndex':'' ]"  
           @click="btnClick(item,index);" type="danger">{{item.hospital +' ('+item.count+")"}}
        </el-button>
      </template>
  </div>
  <div style="display: flex; width: 100%;justify-content: space-between;" >
    <div style="display: flex;width: 100%; height: 50px;align-items: center;margin-left: 20px;">
      <img class="project" src="@/assets/img/project.png" alt="">
      <p class="enrollment" @click="isEnrollment = !isEnrollment">{{ isEnrollment?`排除患者列表（${tableData.length - enrollmentCount}）`:`入组患者列表（${enrollmentCount}）` }}</p>
    </div>
    <el-input 
      v-model="searchname"
      style="width: 240px ;height: 40px;margin-right: 20px;"
      placeholder="请输入您想查询的患者"
    />

      
      <el-select style="width: 240px ;height: 40px;margin-right: 20px;" :disabled="!is_lead" v-model="selectHost" placeholder="Select" >
    <el-option
      v-for="item in hostOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    />
  </el-select>
    
  </div>
  <div :class="['lists',is_lead?'lists_lead':'']" v-if="lists_show">
    <!-- item 每个患者 -->
     <template v-for="(item, index) in tableData">
        <div  v-if="item.isExclude == !isEnrollment" :key="index" class="item">
            <!-- 状态颜色 --> 
            <p v-if="item.fields.vistisState" class="topcolorgreen"></p>
            <p v-else class="topcolorred"></p>
            <div :class="item.fields.vistisState?'baccolorgreen':'baccolorred'">
              <div class="head flex">
                <p @click="details(item.id)" class="head_name">{{ item.fields['患者姓名'] }}</p>
                <p class="card"><span>身份证后六位 | {{ item.fields['身份证后六位']??'无' }}</span></p>
              </div>
              <div style="margin: 5px 0 0 10px;display: flex;justify-content: space-between;padding-right: 5px">
                <p>{{ item.create_name }}</p> 
                  <!-- <p>{{ item.fields[crfForms[3]?.type] }}</p> -->
                <p>入组时间：{{item.fields[crfForms[3].type]?.['访视日期']??'未填写'}}</p></div>
              <div class="item_state flex">
                <p v-if="item.fields.vistisState" class="ok">全部完成</p>
                <p v-else class="not_ok">访视中</p>
                <button @click="planfun(item.id)" class="button">新增计划外访视</button>
                <!-- <p>{{ item }}{{1 }}</p> -->
              </div>
            </div>
            
            <div class="content">
                <!--crf 本地的访视期 -->
                <div class="visits flex" v-for="(crf, crfindex) in item.crfs" :key="crfindex">
                    <!-- 如果死亡后的访视期，不显示 -->
                    <template v-if="!patientStore.shouldShowVisit(item, crf.type)"></template>
                    <template v-else-if="flodshowarrs[index] && crfindex> 3"></template>
                    <template v-else>
                      <p class="visits_name">{{ crf.name }}</p>
                      <div class="state"> 
                          <template v-if="['入选标准','排除标准'].includes(crf.type)">
                            <el-button v-if="item.fields.isStagin?.includes(crf.type) && item.fields[crf.type]" style="width: 100%"
                                      @click="showDialog(item.id, crf)">已暂存
                            </el-button>
                            <el-button v-else-if="!item.fields[crf.type]" type="primary" style="width: 100%"
                                      @click="showDialog(item.id, crf)">{{item.modifiable ==1 ? '填写':'查看'}}
                            </el-button>
                            <el-button v-else style="width: 100%"
                                      @click="showDialog(item.id, crf)">查看
                            </el-button>
                          </template>
                          
                          <template v-else-if="!['入选标准','排除标准'].includes(crf.type) && patientStore.isFill(item)">
                            <!-- <p>{{ patientStore.isFill(item) }}</p> -->
                            <el-button v-if="item.fields.isStagin?.includes(crf.type) && item.fields[crf.type]" style="width: 100%"
                                      @click="showDialog(item.id, crf)">已暂存
                            </el-button>
                            <el-button v-else-if="item.fields[crf.type] && crf.isjhw" type="primary" style="width: 100%"
                                      @click="showJhw(item.id, crf)">查看
                            </el-button>
                            <el-button v-else-if="item.fields[crf.type] && !crf.isjhw" type="primary" style="width: 100%"
                                      @click="showDialog(item.id, crf)">查看
                            </el-button>
                            <el-button v-else type="primary" style="width: 100%"
                                      @click="console.log(item,111,crf);showDialog(item.id, crf)">{{item.modifiable ==1 ? '填写':'查看'}}
                            </el-button>
                          </template>

                          <template v-else-if="!['入选标准','排除标准'].includes(crf.type) && !patientStore.isFill(item)">
                            <!-- 显示病理复核排除 -->
                            <p v-if="item.isExclude === true">已排除</p>
                            <!-- 显示未入选/已排除 -->
                            <template v-else>
                              <p v-if="!patientStore.isIn(item)">未入选&nbsp;&nbsp;</p>
                              <p v-if="!patientStore.isOut(item)">已排除</p>
                            </template>
                          </template>
                      </div>
                    </template>
                    <!-- 每条的区分线 -->
                    <p class="border_bottom" v-if="patientStore.shouldShowVisit(item, crf.type) && (!flodshowarrs[index] || (flodshowarrs[index] && crfindex<4))"></p>
                    
                </div>

                <!-- 计划外访视期 -->
                <!-- <div class="visits flex" v-if="!flodshowarrs[index]" v-for="(crf, index) in item.fields.jhw" :key="index">
                  <p class="visits_name">{{ crf.name }}</p>
                  <p class="state"> 
                    <el-button style="width: 100%" @click="showJhw(item.id, crf)">查看</el-button>
                  </p>
                </div> -->
                <p class="flod" @click="funflod(index)">{{flodshowarrs[index]?'展开全部':'折叠'}}</p>

            </div>
              
        </div>

     </template>
    
  </div>
  <el-table v-loading="loading" :data="tableData" style="width: 100%" :border="true" v-if="0">
    <!-- 姓名一列，label这一列的标题 每一行的内容（）-->
    <el-table-column prop="fields['患者姓名']" label="患者姓名" min-width="100" fixed>
      <template #default="scope">
          <span class="name" @click="details(scope.row.id)">{{ scope.row.fields['患者姓名']?scope.row.fields['患者姓名']:"---" }} </span>         
        </template>
      </el-table-column>

      <!-- 计划外访视 -->
      <el-table-column  label="计划外访视" min-width="100" align="center" header-align="center">
      <template #default="scope">
        <template v-if="patientStore.isFill(scope.row)">
          <el-button @click="planfun(scope.row.id);console.log(scope.row.id,222)"  type="primary">填写</el-button>
        </template>
        <template v-else>-</template>
      </template>
    </el-table-column>

      <!-- 身份证一列 -->
    <el-table-column prop="fields['身份证后六位']" label="身份证后六位" min-width="120"></el-table-column>
    <!-- tableHead 内容 -->
    <!-- <el-table-column v-for="crf in tableHead.tableHead" :label="crf.name" min-width="120" align="center" -->
    <el-table-column v-for="(crf, crfIdx) in crfForms" :key="crfIdx" :label="crf.name" min-width="120" align="center" header-align="center">
      <template #default="scope">
        <template v-if="['入选标准','排除标准'].includes(crf.type)">
          <el-button v-if="!scope.row.fields[crf.type]" type="primary" style="width: 100%"
                     @click="showDialog(scope.row.id, crf)">填写
          </el-button>
          <el-button v-if="scope.row.fields[crf.type]" style="width: 100%"
                     @click="showDialog(scope.row.id, crf)">查看
          </el-button>
        </template>

        <template v-else-if="!['入选标准','排除标准'].includes(crf.type) && patientStore.isFill(scope.row)">
          <el-button v-if="scope.row.fields.isStagin?.includes(crf.type) && scope.row.fields[crf.type]" style="width: 100%"
                     @click="showDialog(scope.row.id, crf)">已暂存
          </el-button>
          <el-button v-else-if="scope.row.fields[crf.type]" type="primary" style="width: 100%"
                     @click="showDialog(scope.row.id, crf)">查看
          </el-button>
          <el-button v-else type="primary" style="width: 100%"
                     @click="console.log(scope.row,111,crf);showDialog(scope.row.id, crf)">填写
          </el-button>
        </template>

        <template v-else-if="!['入选标准','排除标准'].includes(crf.type) && !patientStore.isFill(scope.row)">
          <template v-if="!patientStore.isIn(scope.row)">未入选&nbsp;&nbsp;</template>
          <template v-if="!patientStore.isOut(scope.row)">已排除</template>
        </template>

      </template>
    </el-table-column>
    <!-- 计划外 -->
    <el-table-column v-for="(crf, jhwIdx) in jhw" :key="jhwIdx" :label="crf.name" min-width="120" align="center" header-align="center">
        <template #default="scope">
          <!-- {{ crf.module }} -->
          <!-- <p v-if="scope.row.fields.jhw">{{scope.row.fields.jhwe? JSON.parse(scope.row.fields.jhw).name:-}}</p>
          <p v-else>-</p> -->
            <template v-if="scope.row.fields?.names.includes(crf.name)">
                <el-button style="width: 100%" @click="showJhw(scope.row.id, crf)">查看
                </el-button>
            </template>
            <template v-else>
                -
            </template>

        </template>
    </el-table-column>
   
  </el-table>
  <!-- 站内信 -->
  <el-drawer v-model="commonStore.innermsg" :with-header="false" size="50%" show-close>
      <div class="innerbox">
        <p class="head"><span>通知</span><span @click="commonStore.innermsg = false" >x</span></p>
        <div class="innerlist">
            <p v-for="(item, index) in innerlist" :key="index">
             <el-icon class="icon"><Message /></el-icon><span>{{ getquestiontype(item.status)}}</span> - <span>{{item.patient_name}}</span> <span>{{item.period}}</span> <span>{{ item.title }}</span><span>{{item.created_at }}</span>
            </p>
        </div>
          <!-- <span>Hi there!</span> -->

      </div>
  </el-drawer>
</template> 
<style>
/* 给每个选项加上必填提示，但是取消表单验证 */
  @import "@/styles/redStar.scss";
</style>
<style lang="scss">
  .el-select__wrapper{
    height: 40px !important;
  }
.isLead{
  margin: 20px ;
  display: flex;
  justify-self: start;
  flex-wrap: wrap;
  
  .button{
    background-color: #D84357;
    // margin: 0;
    margin-top: 20px;
  }
  .colorIndex{
    background-color: #97060d;
  }
}
.project{
  width: 40px;
}
.enrollment{
  user-select: none;
  background: #bab5b5;
  border-radius: 5px;
  height: 30px;
  line-height: 30px;
  width: 180px;
  text-align: center;
  margin: 0;
  // margin-left: 20px;
  color: #FFFFFF;
}
.lists{
  display: flex;
  // position: absolute;
  // right: 0;
  // bottom: 0;
  overflow: auto;
  // min-height: 500px;
  height: 72vh;
  // height: 80vh;
  // 子元素不跟随父元素高度（宽度）
  align-items: flex-start;
  padding: 10px 0;
  // margin: 0 20px;
  // padding-right: 50px;
  .topcolorgreen{
      background-color: #66A978;
      height: 4px;
      margin: 0;
  }
  .topcolorred{
      background-color: #D84357;
      height: 4px;
      margin: 0;
  }
  .baccolorred{
    background-color: #FFF2F2;
  }
  .item{
      background: #F8F8F8;
      // border-top: 4px solid #D84357; ;

      box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.12);
      margin-left: 20px;
      // padding:0 10px 0 ;
      box-sizing: border-box;
      width: 240px;
      height: auto;
      flex-shrink: 0;
      // border: 1px solid red;
    .flex{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
   
    .head{
      padding:0 10px 0 ;
     
      .head_name{
        margin: 0;
        font-size: 18px;
        text-align: left;
        width: 35%;
        font-weight: 500;
        line-height: 22px;
        overflow: hidden;
        white-space: nowrap;
        cursor: pointer;
      }
      .head_name:hover{
        color: rgb(80, 13, 203);
        text-decoration: underline;
      }
      .card{
        font-size: 13px;
        color: #999999;
      }
    }
    .item_state{
      // align-items: center;
      padding:0 10px 10px ;
      border-bottom: 1px solid rgba(0,0,0,0.2);
      p{
        margin: 0 ;
        padding-left: 10px;
        font-size: 13px;
        position: relative;

      }
      p::before{
        content: '';
        position: absolute;
        top: 35%;
        left: 0;
        width: 8px;
        height: 8px;
        border-radius: 50%;
      }
      .button{
        font-size: 13px;
        // width: 108px;
        height: 24px;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #CCCCCC;
      }
      .ok{
        color:  #236835;
      }
      .ok::before{
        // content: '';
        background: #66A978;
       
      }
      .not_ok::before{
        // content: '';
        background: #D84357;
       
      }
      .not_ok{
        color:  #D84357;
      }

    }
    .content{
      background-color: #FFFFFF;
      .visits{
        // padding:0 10px 0 ;
        font-size: 14px;
        flex-wrap: wrap;
        // overflow: hidden;
        
        .border_bottom{
          margin: 0;
          width: 100%;
          position: relative;
          // left: -10%;
          // right: -20%;
          height: 1px;
          background-color:rgba(0,0,0,0.2) ;
          // border-bottom: 1px solid ;
        }

        .visits_name{
        padding-left:10px ;
          box-sizing: border-box;
          width: 78%;
          text-align: left;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;

        }
        // 未入选和已排除
        .state{
        padding-right:10px ;
        box-sizing: border-box;

          width: 22%;
          margin: 0;
          p{
            margin: 0;
          white-space: nowrap;
            // padding-left: 13px;
          }
        }
      }
      .flod{
        margin: 0;
        cursor: pointer;
        text-align: center;
        line-height: 32px;
        height: 32px;
        width: 100%;
        border: 0;
        color: #B4B4B4 ;
        background: #F8F8F8;
      }
    }
  }
}
.lists_lead{
  height: 56vh;
}
.name{
 width: 100% ;
 text-align: center; 
 text-decoration: underline;
 cursor: pointer;
}
.name:hover{
  color: rgb(120, 120, 255);
}
  .upload{
    width: 300px;
    height: 300px;
  }
  .v2btn{
    position: relative;
    top: -4px;
    background-color: white;
    margin-left: 50px;
    height: 32px;
    border: 1px rgb(215, 213, 213) solid;
    border-radius: 4px;
  }
  ::v-deep .el-form-item__content{
    width: 300px;
  }
  .innerbox{
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    .head{
      display: flex;
      justify-content: space-between;
      padding-right: 20px;
      box-sizing: border-box;
      font-size: 20px;
      span:nth-child(2){
        cursor: pointer;

      }
    }
    .innerlist{
      display: flex;
      flex-direction: column;
      p{
        margin: 10px;
        .icon{
          background-color: rgb(222, 222, 104);
          padding:0 5px;
          color: #FFFFFF;
          border-radius: 4px;
        }
      }
    }
  }
</style>
